export enum Headings {
    H1 = 'h1',
    H2 = 'h2',
    H3 = 'h3',
    NONE = 'none',
}
